import EventHasVarieties from '../../../../events/eventHasVarieties/EventHasVarieties';
import Vue from 'vue';

export default {

  name: 'varieties-block',

  props: {
    block: {}
  },

  inject: [
    'pageBuilderChildData',
    'storageData',
    'currentLocale',
    'user',
    'editWaitingList'
  ],

  components: {
    'event-has-varieties': EventHasVarieties
  },

  computed: {
    currentDate: function () {
      return new Date();
    }
  },

  methods: {
    alreadyInCart: function () {
      return this.storageData.cart[this.pageBuilderChildData.currentEvent.uuid] !== undefined;
    },

    addEventWithVarietiesToCart: function () {
      this.$emit('addEventWithVarietiesToCart');
    },

    alreadyOnWishList: function () {
      return this.user.userData.wishList[this.pageBuilderChildData.currentEvent.uuid] !== undefined;
    },

    bookingAllowed: function () {
      return this.user.userData.bookingAllowed;
    },

    addToWaitingList: function () {
      let proxy = this;

      this.wishListPromise = this.editWaitingList(this.pageBuilderChildData.currentEvent.uuid, 'add');

      this.wishListPromise.then(data => {
        proxy.addToWishListStatus = data;

        if (proxy.addToWishListStatus.status === 'success') {
          Vue.set(this.user.userData, 'wishList', proxy.addToWishListStatus.wishList);
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/apps/booking/components/pageBuilder/pageBuilderBlock/types/varietiesBlock/VarietiesBlock.js